module.exports = __webpack_public_path__ + "img/kamilkoc.5e4eb9de.png";